export type ContentFilterTag = {
  __typename: string;
  id: string;
  label: string;
  options: {
    __typename: string;
    id: string;
    label: string;
    value: string;
  }[];
};

export type TopicsFilterProps = {
  topics?: ContentFilterTag | null;
  activeFilter?: string[];
  handleFilterChange?: (filterGroup: string, filter: string) => void;
  activeTab?: string;
};

export type ContentFiltersProps = {
  filters: ContentFilterTag[] | undefined;
  activeFilters: Record<string, string[]>;
  onFilterChange: (filterGroup: string, value: string) => void;
  libraryType: string;
};

export type FilterToggleProps = {
  showFilters: boolean;
  activeFilters: Record<string, string[]>;
  handleFilterToggle: () => void;
  activeTab: string;
};

export enum FilterGroups {
  Durations = "durations",
  SetUp = "setup",
  Format = "format",
  Intensity = "intensity",
  Type = "type",
  Practitioners = "practitioners",
  Topics = "topics",
}

export type TabData = {
  items: any[];
  loading: boolean;
  error: any;
};

export type ExtractedFilters = {
  sidebarFilterTags: ContentFilterTag[];
  topics: ContentFilterTag | null;
};
